import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import HeroSection from '../sections/HeroSection';
import FeaturesSection from '../sections/FeaturesSection';
import HowItWorksSection from '../sections/HowItWorksSection';

const MainLayout = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [animationKey, setAnimationKey] = useState(0);
  const location = useLocation();

  // Function to handle navigation clicks
  const handleNavClick = (section) => {
    setActiveSection(section);
    setAnimationKey(prevKey => prevKey + 1); // Increment key to force animation restart
    
    // Smooth scroll to section
    const element = document.getElementById(section === 'home' ? 'hero' : section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Track scroll position to update active section
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      
      // Get all section elements
      const heroSection = document.getElementById('hero');
      const featuresSection = document.getElementById('features');
      const howItWorksSection = document.getElementById('how-it-works');
      
      // Determine which section is currently in view
      if (howItWorksSection && scrollPosition >= howItWorksSection.offsetTop - 200) {
        setActiveSection('how-it-works');
      } else if (featuresSection && scrollPosition >= featuresSection.offsetTop - 200) {
        setActiveSection('features');
      } else {
        setActiveSection('home');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-black text-white">
      <Header activeSection={activeSection} handleNavClick={handleNavClick} />
      
      <AnimatePresence mode="wait">
        <div key={animationKey}>
          <HeroSection />
          <FeaturesSection />
          <HowItWorksSection />
        </div>
      </AnimatePresence>
      
      <Footer />
    </div>
  );
};

export default MainLayout; 